import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { FeedbackPromptBar } from './FeedbackPromptBar';
import frameLayoutStyles from './frame-layout.module.scss';
import { MessageFrame } from './MessageFrame';
import { MessageItems } from './MessageItems';
import { ProposalActionsRow } from './ProposalActionsRow';
import { ProposalItemCard } from './ProposalItemCard';
import { ProposalItemCheckbox } from './ProposalItemCheckbox';
export const GetConfirmationSummaryMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ConfirmationSummaryMessage = (param)=>{
    let { content, messageId, interactive, onDismiss, onApply, onSubmitFeedback, onDismissFeedback, frameClassName, floating, scrollable } = param;
    const { ConfirmationSummaryMessageTID } = useMemo(()=>GetConfirmationSummaryMessageTID(messageId), [
        messageId
    ]);
    const [itemChecked, setItemChecked] = useState(()=>{
        const initial = {};
        content.items.forEach((i)=>initial[i.id] = i.checked);
        return initial;
    });
    const toggleItem = (itemId)=>setItemChecked((prev)=>_object_spread_props(_object_spread({}, prev), {
                [itemId]: !prev[itemId]
            }));
    const allItemIds = content.items.map((i)=>i.id);
    const selectedItemIds = allItemIds.filter((id)=>itemChecked[id]);
    const isCards = content.renderKind === 'cards';
    const renderItem = (item)=>'groups' in item ? /*#__PURE__*/ _jsx(ProposalItemCard, {
            item: item,
            checked: !!itemChecked[item.id],
            disabled: !interactive,
            onChange: ()=>toggleItem(item.id),
            testId: ConfirmationSummaryMessageTID.Item(item.id)
        }, item.id) : /*#__PURE__*/ _jsx(ProposalItemCheckbox, {
            item: item,
            checked: !!itemChecked[item.id],
            disabled: !interactive,
            onChange: ()=>toggleItem(item.id),
            testId: ConfirmationSummaryMessageTID.Item(item.id)
        }, item.id);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        width: "100%",
        className: frameLayoutStyles.fillSlot,
        children: [
            /*#__PURE__*/ _jsxs(MessageFrame, {
                testId: ConfirmationSummaryMessageTID.Root(),
                padding: "16px 0 0 0",
                fillHeight: true,
                className: frameClassName,
                floating: floating,
                scrollable: scrollable,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: ConfirmationSummaryMessageTID.Intro(),
                        className: frameLayoutStyles.framePad,
                        showWhiteSpaces: true,
                        applyMarkdownBold: true,
                        children: content.intro
                    }),
                    /*#__PURE__*/ _jsx(MessageItems, {
                        testId: ConfirmationSummaryMessageTID.Items(),
                        gap: 8,
                        children: isCards ? /*#__PURE__*/ _jsx(Row, {
                            gap: 8,
                            width: "100%",
                            testId: ConfirmationSummaryMessageTID.CardsRow(),
                            children: content.items.map(renderItem)
                        }) : content.items.map(renderItem)
                    }),
                    interactive && /*#__PURE__*/ _jsx(ProposalActionsRow, {
                        className: frameLayoutStyles.frameFooter,
                        selectedCount: selectedItemIds.length,
                        applySelectedLabel: content.applySelectedLabel,
                        applyAllLabel: content.applyAllLabel,
                        dismissLabel: content.dismissLabel,
                        applySelectedDisabled: selectedItemIds.length === 0,
                        onApplySelected: ()=>onApply(messageId, selectedItemIds),
                        onApplyAll: ()=>onApply(messageId, allItemIds),
                        onDismiss: ()=>onDismiss(messageId),
                        dismissTestId: ConfirmationSummaryMessageTID.Dismiss(),
                        applySelectedTestId: ConfirmationSummaryMessageTID.ApplySelected(),
                        applyAllTestId: ConfirmationSummaryMessageTID.ApplyAll()
                    })
                ]
            }),
            content.feedbackPrompt != null && onSubmitFeedback != null && onDismissFeedback != null && /*#__PURE__*/ _jsx(FeedbackPromptBar, {
                prompt: content.feedbackPrompt,
                onSubmit: onSubmitFeedback,
                onDismiss: onDismissFeedback,
                testId: messageId
            })
        ]
    });
};
